import React from 'react';
import PropTypes from 'prop-types';
import './App.css';
import AppHOC from './AppHOC';
import { RouterProvider } from 'react-router-dom';
import router from 'router/index.jsx';
import { AnalyticsIdentitySync } from 'services/analytics';

import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useGetFeatureConfigQuery, useGetAppUpdateConfigQuery } from 'store/api/common.apislice';
import { setFeatureConfig } from 'store/slices/config.slice';
import useAppVersion from 'hooks/useAppVersion.hook';
import useDeviceInfo from 'hooks/useDeviceInfo.hook';
import { isNative } from 'utils/platform.utils';
import { isVersionLessThan } from 'utils/versionManager.utils';
import UpdateModalComponent from 'components/common/UpdateModalComponent';

function App() {
  const dispatch = useDispatch();
  const { data: featureTimeout } = useGetFeatureConfigQuery();

  // App Update States
  const { version: currentVersion } = useAppVersion();
  const { deviceInfo } = useDeviceInfo();
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateType, setUpdateType] = useState('partial'); // 'force' or 'partial'
  const [updateInfo, setUpdateInfo] = useState(null);

  const osType = deviceInfo?.platform?.toUpperCase() || 'ANDROID';

  // Fetch update config only for native platforms
  const { data: updateConfig } = useGetAppUpdateConfigQuery(osType, {
    skip: !isNative() || !deviceInfo
  });

  useEffect(() => {
    if (featureTimeout?.result) {
      dispatch(setFeatureConfig(featureTimeout.result));
    }
  }, [featureTimeout, dispatch]);

  // Handle version comparison and showing modal
  useEffect(() => {
    if (isNative() && updateConfig?.result && currentVersion) {
      const config = updateConfig.result;
      const latestVersion = config.app_version;
      const configKey = config.config_key; // 'FORCE_UPDATE' or 'OPTIONAL_UPDATE'

      if (isVersionLessThan(currentVersion, latestVersion)) {
        setUpdateType(configKey === 'FORCE_UPDATE' ? 'force' : 'partial');
        setUpdateInfo({
          latestVersion: latestVersion,
          currentVersion: currentVersion,
          releaseNotes: config?.config_value,
          updateUrl: config?.store_link || null // Direct store URL from API (Play Store / App Store)
        });
        setShowUpdateModal(true);
      }
    }
  }, [updateConfig, currentVersion]);

  return (
    <AppHOC>
      <AnalyticsIdentitySync />
      <RouterProvider router={router} />
      {showUpdateModal && (
        <UpdateModalComponent
          open={showUpdateModal}
          updateType={updateType}
          updateInfo={updateInfo}
          onClose={() => updateType !== 'force' && setShowUpdateModal(false)}
          onUpdateLater={() => setShowUpdateModal(false)}
          platform={osType.toLowerCase()}
        />
      )}
    </AppHOC>
  );
}

App.propTypes = {
  // No props for this component
};

export default App;
